import * as _ from "lodash";

// updateCustomerData accepts a Delivery visitor address write only for one real
// address object (normalizeVisitorAddress). These checks are a strict SUBSET of
// the server's: they catch only values the server is certain to reject, so the
// app never claims a visitor slot for an address that cannot be saved.
// 2026-10-02 (1248h534k1a): an app reopen posted a non-object address and was
// rejected with visitor_address_invalid / address_not_object.
function isUsableAddressValue(value: any): boolean {
  if (typeof value === "number") {
    return Number.isFinite(value);
  }
  if (typeof value !== "string") {
    return false;
  }
  const trimmed = value.trim();
  return trimmed !== "" && trimmed.toLowerCase() !== "null";
}

export function isUsableDeliveryVisitorAddress(address: any): boolean {
  return (
    _.isPlainObject(address) &&
    isUsableAddressValue(address.address_id) &&
    isUsableAddressValue(address.formatted_address)
  );
}

// The address write answers with a bare code (visitor_address_invalid), while the
// visitor messages live under errorMessages.*. No MissingTranslationHandler is
// configured, so an unknown key would reach the guest verbatim.
export function getDeliveryVisitorAddressErrorKey(
  commentId: any,
  hasTranslation: (key: string) => boolean
): string {
  if (typeof commentId === "string" && commentId.trim() !== "") {
    if (hasTranslation(commentId)) {
      return commentId;
    }
    const prefixed = "errorMessages." + commentId;
    if (hasTranslation(prefixed)) {
      return prefixed;
    }
  }
  return "errorMessages.general_error";
}
